import { BaseResponse, RequestConfig } from 'common/types/api'
import axios from 'core/api'

import {
  SearchHistoryResponse,
  SearchHistoryRequest,
  FoodComparisonResponse,
  FoodStandardResponse,
  GrowthComparisonResponse,
  GrowthStandardResponse,
  DOComparisonResponse,
  PHComparisonResponse,
  TableComparisonResponse
} from './types'

export const getSearchHistory = () =>
  axios.get<BaseResponse<SearchHistoryResponse[]>>('/pond-comparison/search/history')

export const saveSearchHistory = (data: SearchHistoryRequest) =>
  axios.post<BaseResponse<SearchHistoryResponse>>('/pond-comparison/search/history', data)

export const deleteSearchHistory = (id: string) =>
  axios.delete<BaseResponse<void>>(`/pond-comparison/search/history/${id}`)

export const getFoodComparison = (params?: any) =>
  axios.get<BaseResponse<FoodComparisonResponse>>('/pond-comparison/food', { params })

export const getFoodStandard = (params?: any) =>
  axios.get<BaseResponse<FoodStandardResponse[]>>('/pond-comparison/food/standard', { params })

export const getGrowthComparison = (params?: any) =>
  axios.get<BaseResponse<GrowthComparisonResponse>>('/pond-comparison/growth', { params })

export const getGrowthStandard = (params?: any) =>
  axios.get<BaseResponse<GrowthStandardResponse[]>>('/pond-comparison/growth/standard', { params })

export const getDOComparison = (params?: any) =>
  axios.get<BaseResponse<DOComparisonResponse>>('/pond-comparison/do', { params })

export const getPHComparison = (params?: any) =>
  axios.get<BaseResponse<PHComparisonResponse>>('/pond-comparison/ph', { params })

export const getTableComparison = (params?: any) =>
  axios.get<BaseResponse<TableComparisonResponse[]>>('/pond-comparison/table', { params })
